exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Button-With-Helpers{position:relative}.Login-Button-Helpers{font-size:15px;color:#000;position:absolute;top:50px;left:0;right:0;text-align:center}@media (max-height:640px){.Login-Button-Helpers{display:none}}.Login-Button-Helpers svg{width:20px;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/components/SignupButton.css
// module id = ./src/components/SignupButton.css
// module chunks = 2345137460201621000 13254968351354405000 17463659626562118000